import { getMailboxKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import { getRowKeysFromRowIds, getStore as getListViewStore, getTableToRowRelationKey, isMailListConversationView } from "owa-mail-list-store";
import getAllTableViewsContainingItems from "owa-mail-triage-table-utils/lib/getAllTableViewsContainingItems";

type ListViewReferenceState = Pick<ReturnType<typeof getListViewStore>, "tableViews" | "tableViewItemRelations">;

export default function isItemHeldByListViewTable(itemId: string, mailboxInfo: MailboxInfo, parentFolderId: string | undefined, state: ListViewReferenceState = getListViewStore()): boolean {
    const tableViews = parentFolderId
        ? getAllTableViewsContainingItems(mailboxInfo, parentFolderId, true /* shouldIncludeSearchTable */)
        : [...state.tableViews.values()];
    const mailboxKey = parentFolderId ? undefined : getMailboxKeyForMailboxInfo(mailboxInfo);
    
    for (const tableView of tableViews) {
        if (isMailListConversationView(tableView)) {
            continue;
        }
        
        const rowKeys = getRowKeysFromRowIds([itemId], tableView);
        for (const rowKey of rowKeys) {
            if (tableView.rowKeys.indexOf(rowKey) < 0) {
                continue;
            }
            
            if (parentFolderId) {
                return true;
            }
            
            const relation = state.tableViewItemRelations.get(getTableToRowRelationKey(rowKey, tableView.id));
            if (relation &&
                getMailboxKeyForMailboxInfo(relation.clientId.mailboxInfo) === mailboxKey) {
                return true;
            }
        }
    }
    
    return false;
}
